import { render, staticRenderFns } from "./BatchAppeals.vue?vue&type=template&id=4e862bb8"
import script from "./BatchAppeals.vue?vue&type=script&lang=js"
export * from "./BatchAppeals.vue?vue&type=script&lang=js"
import style0 from "./BatchAppeals.vue?vue&type=style&index=0&id=4e862bb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports